module.exports = __webpack_public_path__ + "static/media/MIAB9261-180730-31_Small.7c2b6aed.jpg";